import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "py-4 px-5" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "white--text font-weight-bold" }
const _hoisted_4 = { class: "vertical-sticky-end" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["colspan"]
const _hoisted_7 = { class: "d-flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_TasksCalendar = _resolveComponent("TasksCalendar")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_select_user = _resolveComponent("select-user")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_TaskDialog = _resolveComponent("TaskDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.activeTab,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
              style: {"border-radius":"16px","overflow":"hidden"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, {
                  value: "TaskCalendar",
                  "data-cy": "tasks-calendar-tab"
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("Calendrier")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  value: "TaskRecurringDashboard",
                  "data-cy": "tasks-recurring-tab"
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode("Tâches Récurrentes")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "my-3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "pr-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_primary, {
                      block: "",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearNewToTaskCreate()))
                    }, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createTextVNode("Ajouter")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "pl-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      readonly: "",
                      clearable: "",
                      label: "Créé par",
                      onClick: _ctx.openUserDialog,
                      "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearUserSelectedFilter(_ctx.selectedUser, 1))),
                      "model-value": _ctx.displaySelectedUser(_ctx.selectedUser),
                      density: "compact"
                    }, null, 8, ["onClick", "model-value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "pl-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      readonly: "",
                      clearable: "",
                      label: "Attribué à",
                      onClick: _ctx.openMemberDialog,
                      "onClick:clear": _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearUserSelectedFilter(_ctx.selectedMember, 2))),
                      "model-value": _ctx.displaySelectedUser(_ctx.selectedMember),
                      density: "compact"
                    }, null, 8, ["onClick", "model-value"])
                  ]),
                  _: 1
                }),
                (_ctx.$router.currentRoute.value.name !== 'tasks')
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "2",
                      class: "pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.companySelectedFilter,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.companySelectedFilter) = $event)),
                          items: _ctx.allAvailableCompanies,
                          clearable: true,
                          outlined: "",
                          "item-value": "id",
                          "hide-details": "",
                          label: "Entreprises Tiers",
                          "onClick:clear": _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearCompanySelectedFilter())),
                          density: "compact",
                          "item-title": (item) => item.name
                        }, null, 8, ["modelValue", "items", "item-title"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.activeTab !== 'TaskRecurringDashboard')
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "2",
                      class: "pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.typeStatusFilter,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.typeStatusFilter) = $event)),
                          items: _ctx.typesStatus,
                          outlined: "",
                          "item-value": "value",
                          "hide-details": "",
                          label: "Statut",
                          "onClick:clear": _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearStatusSelectedFilter())),
                          density: "compact",
                          "item-title": (item) => item.name
                        }, null, 8, ["modelValue", "items", "item-title"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.activeTab === 'TaskRecurringDashboard')
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 2,
                      cols: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DateRangePicker, {
                          class: "d-flex pl-4",
                          begin: _ctx.startPeriodicityDate,
                          end: _ctx.endPeriodicityDate,
                          onChangeDateRange: _ctx.onDateRangeChanged,
                          hideDetails: true,
                          type: 'month',
                          dense: ""
                        }, null, 8, ["begin", "end", "onChangeDateRange"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_window, {
              modelValue: _ctx.activeTab,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.activeTab) = $event)),
              style: {"background-color":"transparent !important"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: "TaskCalendar" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            (_ctx.accountingFirmId)
                              ? (_openBlock(), _createBlock(_component_TasksCalendar, {
                                  key: 0,
                                  accountingFirmId: _ctx.accountingFirmId,
                                  clientId: _ctx.companySelectedFilter,
                                  selectedUser: _ctx.selectedUser,
                                  selectedMember: _ctx.selectedMember,
                                  companySelectedFilter: _ctx.companySelectedFilter,
                                  typeStatusFilter: _ctx.typeStatusFilter,
                                  tasksFromParentComponent: _ctx.tasksDatabase,
                                  onTaskDate: _cache[8] || (_cache[8] = ($event: any) => (_ctx.receiveTaskDate($event))),
                                  onEditEvent: _cache[9] || (_cache[9] = ($event: any) => (_ctx.editTask($event)))
                                }, null, 8, ["accountingFirmId", "clientId", "selectedUser", "selectedMember", "companySelectedFilter", "typeStatusFilter", "tasksFromParentComponent"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "TaskRecurringDashboard" }, {
                  default: _withCtx(() => [
                    (_ctx.loadingTasks || !_ctx.tasksRecurring || !_ctx.tasksRecurring.length)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                  elevation: "0",
                                  style: {"background-color":"#ffffff","border-radius":"25px"}
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.loadingTasks)
                                      ? (_openBlock(), _createBlock(_component_v_card_title, {
                                          key: 0,
                                          class: "pa-4 d-flex justify-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_progress_circular, {
                                              indeterminate: "",
                                              class: "mr-3"
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : (!_ctx.tasksRecurring || !_ctx.tasksRecurring.length)
                                        ? (_openBlock(), _createBlock(_component_v_card_title, {
                                            key: 1,
                                            class: "pa-4 d-flex justify-center"
                                          }, {
                                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                                              _createTextVNode(" Pas de tâches récurrentes pour ce Collaborateur et/ou cette société ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "pt-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_oss_data_table, {
                                  headers: _ctx.tasksRecurringTableHeaders,
                                  items: _ctx.tasksRecurring,
                                  itemLength: _ctx.tasksRecurringLength,
                                  "show-select": false,
                                  "x-dense": true,
                                  striped: true,
                                  "table-hover": true,
                                  "fixed-footer": true,
                                  "fixed-header": true,
                                  "checkbox-color": "primary"
                                }, {
                                  "header.dueDate": _withCtx(({ header }) => [
                                    _createTextVNode(_toDisplayString(_ctx.displayHeaderDate(header.text)), 1)
                                  ]),
                                  item: _withCtx((props) => [
                                    _createElementVNode("tr", {
                                      onClick: ($event: any) => (_ctx.expandedRecurringTasksInTask(props.item))
                                    }, [
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_v_btn, {
                                          color: "primary",
                                          elevation: "0",
                                          class: "mx-1",
                                          onClick: _withModifiers(($event: any) => (
                                                        _ctx.expandedRecurringTasksInTask(props.item)
                                                    ), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.taskIdOfRecurringTaskExpanded(
                                                                props.item.id,
                                                            )
                                                                ? "$fa-chevron-up"
                                                                : "$fa-chevron-down"), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.formatCompany(props.item.client)), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.formatType(props.item.type)), 1),
                                      _createElementVNode("td", null, _toDisplayString(props.item.title), 1),
                                      _createElementVNode("td", null, _toDisplayString(props.item.description), 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rangeDates, (date, i) => {
                                        return (_openBlock(), _createElementBlock("td", {
                                          key: i,
                                          class: "text-center"
                                        }, [
                                          (
                                                        _ctx.checkStartDateTask(date, props.item.tasks)
                                                    )
                                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                key: 0,
                                                location: "bottom"
                                              }, {
                                                activator: _withCtx(({ props }) => [
                                                  _createVNode(_component_v_avatar, _mergeProps({
                                                    color: 
                                                                _ctx.changeColorTaskStatus(
                                                                    date,
                                                                    props.item.tasks,
                                                                )
                                                            ,
                                                    size: "20",
                                                    ref_for: true
                                                  }, props, {
                                                    onClick: _withModifiers(($event: any) => (
                                                                _ctx.changeTaskStatus(
                                                                    date,
                                                                    props.item.tasks,
                                                                    null,
                                                                    null,
                                                                )
                                                            ), ["stop"])
                                                  }), {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.displayDateAvatar(
                                                                        props.item.start,
                                                                    )), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1040, ["color", "onClick"])
                                                ]),
                                                default: _withCtx(() => [
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.setStatusTaskOfRecurringTask(
                                                            date,
                                                            props.item.tasks,
                                                        )), 1)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128)),
                                      _createElementVNode("td", _hoisted_4, [
                                        _createVNode(_component_v_menu, {
                                          absolute: "",
                                          "offset-y": ""
                                        }, {
                                          activator: _withCtx(({ props }) => [
                                            _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                                              class: "mx-1",
                                              color: "primary"
                                            }), null, 16)
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item, {
                                                  onClick: _withModifiers(($event: any) => (_ctx.editTask(props.item)), ["stop"])
                                                }, {
                                                  append: _withCtx(() => [
                                                    (props.item.auto === true)
                                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                                          key: 0,
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                            _createTextVNode("$oss-eye")
                                                          ])),
                                                          _: 1
                                                        }))
                                                      : (_openBlock(), _createBlock(_component_v_icon, {
                                                          key: 1,
                                                          size: "small"
                                                        }, {
                                                          default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                            _createTextVNode("$oss-edit")
                                                          ])),
                                                          _: 1
                                                        }))
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(props.item.auto === true
                                                                    ? "Visualiser"
                                                                    : "Modifier"), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]),
                                                _createVNode(_component_v_list_item, {
                                                  onClick: _withModifiers(($event: any) => (_ctx.deleteTask(props.item)), ["stop"])
                                                }, {
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_v_icon, { size: "small" }, {
                                                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                                                        _createTextVNode("$oss-trash")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                        _createTextVNode("Supprimer")
                                                      ])),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ])
                                    ], 8, _hoisted_2),
                                    (_ctx.taskIdOfRecurringTaskExpanded(props.item.id))
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                                          _cache[32] || (_cache[32] = _createElementVNode("td", { style: {"background":"#f4f4f4"} }, null, -1)),
                                          _createElementVNode("td", {
                                            colspan: _ctx.tasksRecurringTableHeaders.length,
                                            style: {"padding":"0","background":"#f4f4f4"},
                                            class: "py-2 px-0"
                                          }, [
                                            _createVNode(_component_oss_data_table, {
                                              headers: _ctx.tasksOfRecurringTaskTableHeaders,
                                              items: props.item.tasks,
                                              itemLength: 
                                                        _ctx.tasksOfRecurringTaskLength(props.item.tasks)
                                                    ,
                                              "show-select": false,
                                              "x-dense": true,
                                              "virtual-scroll": true,
                                              width: '100%',
                                              displayRowNumber: true,
                                              striped: true,
                                              "table-hover": true,
                                              "fixed-footer": true,
                                              "fixed-header": true,
                                              "checkbox-color": "primary",
                                              onClickRow: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editTask($event)))
                                            }, {
                                              "item.menu": _withCtx(({ item }) => [
                                                _createElementVNode("div", _hoisted_7, [
                                                  _createVNode(_component_v_menu, {
                                                    absolute: "",
                                                    "offset-y": ""
                                                  }, {
                                                    activator: _withCtx(({ props }) => [
                                                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                                                        class: "mx-1",
                                                        color: "primary"
                                                      }), null, 16)
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_list, null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_list_item, {
                                                            onClick: _withModifiers(($event: any) => (_ctx.editTask(item)), ["stop"])
                                                          }, {
                                                            append: _withCtx(() => [
                                                              (
                                                                                    props.item
                                                                                        .auto ===
                                                                                    true
                                                                                )
                                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                                    key: 0,
                                                                    size: "small"
                                                                  }, {
                                                                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                                      _createTextVNode("$oss-eye")
                                                                    ])),
                                                                    _: 1
                                                                  }))
                                                                : (_openBlock(), _createBlock(_component_v_icon, {
                                                                    key: 1,
                                                                    size: "small"
                                                                  }, {
                                                                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                                                                      _createTextVNode("$oss-edit")
                                                                    ])),
                                                                    _: 1
                                                                  }))
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_list_item_title, null, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode(_toDisplayString(item.auto === true
                                                                                ? "Visualiser"
                                                                                : "Modifier"), 1)
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["onClick"]),
                                                          _createVNode(_component_v_list_item, {
                                                            onClick: _withModifiers(($event: any) => (
                                                                            _ctx.deleteTask(item)
                                                                        ), ["stop"])
                                                          }, {
                                                            append: _withCtx(() => [
                                                              _createVNode(_component_v_icon, { size: "small" }, {
                                                                default: _withCtx(() => _cache[31] || (_cache[31] = [
                                                                  _createTextVNode("$oss-trash")
                                                                ])),
                                                                _: 1
                                                              })
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_v_list_item_title, null, {
                                                                default: _withCtx(() => _cache[30] || (_cache[30] = [
                                                                  _createTextVNode("Supprimer")
                                                                ])),
                                                                _: 1
                                                              })
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["onClick"])
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ])
                                              ]),
                                              "item.members": _withCtx(({ item }) => [
                                                _createTextVNode(_toDisplayString(_ctx.formatSelectedUsers(item.members)), 1)
                                              ]),
                                              "item.dueDate": _withCtx(({ item }) => [
                                                _createTextVNode(_toDisplayString(_ctx.formatDate(item.dueDate)), 1)
                                              ]),
                                              "item.start": _withCtx(({ item }) => [
                                                _createTextVNode(_toDisplayString(_ctx.formatDate(item.start)), 1)
                                              ]),
                                              "item.status": _withCtx(({ item }) => [
                                                (_ctx.statusIcon(item.status))
                                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                      key: 0,
                                                      location: "start"
                                                    }, {
                                                      activator: _withCtx(({ props }) => [
                                                        _createVNode(_component_v_icon, _mergeProps({
                                                          color: _ctx.statusColor(item),
                                                          onClick: _withModifiers(($event: any) => (
                                                                        _ctx.changeTaskStatus(
                                                                            _ctx.date,
                                                                            null,
                                                                            item,
                                                                            null,
                                                                        )
                                                                    ), ["stop"]),
                                                          size: "small"
                                                        }, props), {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.statusIcon(item.status)), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1040, ["color", "onClick"])
                                                      ]),
                                                      default: _withCtx(() => [
                                                        _createElementVNode("span", null, _toDisplayString(_ctx.statusText(item)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1032, ["headers", "items", "itemLength"])
                                          ], 8, _hoisted_6)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["headers", "items", "itemLength"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.userDialog,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.userDialog) = $event)),
      title: 'Créé par',
      "max-width": "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_select_user, {
          class: "px-1",
          modelValue: _ctx.selectedUser,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedUser) = $event)),
          companyId: _ctx.accountingFirmId,
          availableCompanyId: _ctx.selectedCompany ? _ctx.selectedCompany.id : '',
          type: 'NATURAL_PERSON',
          withEmail: true,
          onUserSelected: _cache[13] || (_cache[13] = ($event: any) => (_ctx.userDialog = false))
        }, null, 8, ["modelValue", "companyId", "availableCompanyId"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.memberDialog,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.memberDialog) = $event)),
      title: 'Attribué à',
      "max-width": "800px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_select_user, {
          class: "px-1",
          modelValue: _ctx.selectedMember,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.selectedMember) = $event)),
          companyId: _ctx.accountingFirmId,
          availableCompanyId: _ctx.selectedCompany ? _ctx.selectedCompany.id : '',
          type: 'NATURAL_PERSON',
          withEmail: true,
          onUserSelected: _cache[16] || (_cache[16] = ($event: any) => (_ctx.memberDialog = false))
        }, null, 8, ["modelValue", "companyId", "availableCompanyId"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.taskDialog)
      ? (_openBlock(), _createBlock(_component_TaskDialog, {
          key: 0,
          modelValue: _ctx.taskDialog,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.taskDialog) = $event)),
          onTaskCreated: _cache[19] || (_cache[19] = ($event: any) => (_ctx.receiveTask())),
          tasksDatabase: _ctx.tasksDatabase,
          taskDate: _ctx.taskDate,
          isNewTask: _ctx.isNewTask,
          isEditTask: _ctx.isEditTask,
          taskToEdit: _ctx.taskReceive
        }, null, 8, ["modelValue", "tasksDatabase", "taskDate", "isNewTask", "isEditTask", "taskToEdit"]))
      : _createCommentVNode("", true)
  ]))
}